var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 37.5H32.5V22.5H40L30 10L20 22.5H27.5V37.5Z",
    fill: "#757A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45H10V27.5H5V45C5 47.7575 7.2425 50 10 50H50C52.7575 50 55 47.7575 55 45V27.5H50V45Z",
    fill: "#757A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconnew);
export default __webpack_public_path__ + "static/media/iconnew.319922a5b228ba2454a8c637b554a653.svg";
export { ForwardRef as ReactComponent };